module.exports = __webpack_public_path__ + "img/linguistic.789bc26e.png";